import { render, staticRenderFns } from "./VoteButtonList.vue?vue&type=template&id=d6aa3a16&scoped=true"
import script from "./VoteButtonList.vue?vue&type=script&lang=ts"
export * from "./VoteButtonList.vue?vue&type=script&lang=ts"
import style0 from "./VoteButtonList.vue?vue&type=style&index=0&id=d6aa3a16&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6aa3a16",
  null
  
)

export default component.exports